export default "__VITE_ASSET__b1de1a20__"